import { GuestAssetCardController } from './guest-asset-card.controller'

const component = {
  bindings: {
    asset: '<',
    onSelect: '&',
    assetPackId: '<',
    isSelected: '<?'
  },
  templateUrl: '/guest/components/guest-asset-card/guest-asset-card.html?$$REVISION$$',
  controller: GuestAssetCardController,
  controllerAs: '$ctrl'
}

export const guestAssetCard = component
